import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, isRef as _isRef } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "side-menu-field-descr text-truncate"
}
const _hoisted_2 = { class: "field-input pt-1" }
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = { class: "pl-2" }

import {__} from "~/ts/library/Translate";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import getOperatorDisplayName from "~/operatorApplication/ts/service/operators/getOperatorDisplayName";
import SideMenuCardSection from "~/operatorApplication/vue/dialogs/dialog/sidemenu/SideMenuCardSection.vue";
import CoreUiOperatorAvatar from "~/core-ui/vue/chat/CoreUiOperatorAvatar.vue";
import {computed} from "vue";
import OperatorSelectTag
    from "~/operatorApplication/vue/dialogs/dialog/sidemenu/info/attachedOperatorsSelect/OperatorSelectTag.vue";
import {toggleArrayElement} from "~/ts/library/ToggleArrayElement";
import OperatorApiRequest from "~/operatorApplication/ts/request/OperatorApiRequest";
import Delay from "~/ts/library/Delay";


import {defineComponent} from 'vue';

const __default__ = defineComponent({
    name: "AttachedOperatorsSelect"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    userdata: {},
    site: {},
    readonly: { type: Boolean },
    placeholder: {}
  },
  setup(__props: any) {

let props = __props;

let canChangeClientAttachedOperators = computed(() => !props.userdata.isFromPersonalOperatorLink && !props.readonly && OperatorAccountStore.data.value.accessRights.canChangeClientAttachedOperators);

let attachedOperatorLogins = computed({
    get(): string[] {
        return props.userdata.attachedOperators.filter(login => props.site.operators.includes(login));
    },
    set(value: string[]) {
        props.userdata.attachedOperators = value;
    }
});

async function onAttachedOperatorLoginsChange(logins: string[]) {
    try {
        await Delay.make(1000, `onAttachedOperatorLoginsChange_${props.userdata.username}`, true);
        if (canChangeClientAttachedOperators.value) {
            let p: OperatorApplicationApi.OperatorBuddyListSaveAttachedOperatorsOpenApiModel = {
                username: props.userdata.username,
                operatorLogins: logins
            };
            await (new OperatorApiRequest({
                url: "/buddyList/saveAttachedOperators",
                p,
                silent: true
            })).send();
        }
    } catch (e) {
    }
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return ((__props.site.isPermanentAttachClientToOperators && _unref(canChangeClientAttachedOperators)) || __props.userdata.attachedOperators.length > 0)
    ? (_openBlock(), _createBlock(SideMenuCardSection, {
        key: 0,
        class: "operator-side-menu-field",
        compact: ""
      }, {
        default: _withCtx(() => [
          (__props.userdata.attachedOperators.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(__props.userdata.isFromPersonalOperatorLink ? _unref(__)("Персональная ссылка оператора") : _unref(__)('Закрепленные операторы')), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_el_select, {
              modelValue: _unref(attachedOperatorLogins),
              "onUpdate:modelValue": [
                _cache[0] || (_cache[0] = ($event: any) => (_isRef(attachedOperatorLogins) ? (attachedOperatorLogins).value = $event : attachedOperatorLogins = $event)),
                onAttachedOperatorLoginsChange
              ],
              multiple: "",
              placeholder: _unref(__)('Закрепленные операторы'),
              persistent: _unref(attachedOperatorLogins).length > 0,
              class: "w-100",
              disabled: !_unref(canChangeClientAttachedOperators)
            }, {
              tag: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.userdata.attachedOperators, (login) => {
                  return (_openBlock(), _createElementBlock(_Fragment, null, [
                    (_unref(OperatorAccountStore).operatorsDictionary.value[login])
                      ? (_openBlock(), _createBlock(OperatorSelectTag, {
                          key: 0,
                          operator: _unref(OperatorAccountStore).operatorsDictionary.value[login],
                          closable: _unref(canChangeClientAttachedOperators),
                          onClose: ($event: any) => {_unref(toggleArrayElement)(__props.userdata.attachedOperators, login, false); onAttachedOperatorLoginsChange(__props.userdata.attachedOperators);}
                        }, null, 8, ["operator", "closable", "onClose"]))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 256))
              ]),
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(OperatorAccountStore).getOperatorsOfSite(__props.site), (operator) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: operator.id,
                    value: operator.login,
                    label: operator.fio
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_3, [
                        _createVNode(CoreUiOperatorAvatar, {
                          operator: operator,
                          size: "2em"
                        }, null, 8, ["operator"]),
                        _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(getOperatorDisplayName)(operator)), 1)
                      ])
                    ]),
                    _: 2
                  }, 1032, ["value", "label"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "placeholder", "persistent", "disabled"])
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})